(function () {
  'use strict';

  var SELECTORS = {
    drawer:      '[data-vrs-cart-drawer]',
    body:        '[data-vrs-cart-body]',
    foot:        '[data-vrs-cart-foot]',
    count:       '[data-vrs-cart-count]',
    subtotal:    '[data-vrs-cart-subtotal]',
    total:       '[data-vrs-cart-total]',
    lines:       '[data-vrs-cart-lines]',
    line:        '[data-vrs-cart-line]',
    qtyDec:      '[data-vrs-qty-dec]',
    qtyInc:      '[data-vrs-qty-inc]',
    qtyInput:    '[data-vrs-qty-input]',
    lineRemove:  '[data-vrs-line-remove]',
    close:       '[data-vrs-cart-close]',
    openTrigger: '[data-vrs-cart-open]',
    addForm:     'form[action*="/cart/add"]'
  };

  var drawer = document.querySelector(SELECTORS.drawer);
  if (!drawer) return;

  var lastFocused = null;

  /* ── Open / Close ─────────────────────────────────────── */

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('varsy-cart-drawer--open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector(SELECTORS.close);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('varsy-cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!drawer.classList.contains('varsy-cart-drawer--open')) drawer.hidden = true;
    }, 380);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* Intercept all /cart links and explicit open triggers */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(SELECTORS.openTrigger);
    if (trigger) {
      e.preventDefault();
      openDrawer();
      return;
    }

    /* Intercept cart page links */
    var cartLink = e.target.closest('a[href]');
    if (cartLink) {
      var href = cartLink.getAttribute('href');
      var cartPath = (window.routes && window.routes.cart_url) || '/cart';
      if (href && (href === '/cart' || href === cartPath || href.endsWith('/cart'))) {
        e.preventDefault();
        openDrawer();
        return;
      }
    }

    if (e.target.closest(SELECTORS.close)) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('varsy-cart-drawer--open')) closeDrawer();
  });

  /* ── AJAX add-to-cart ─────────────────────────────────── */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest(SELECTORS.addForm);
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/javascript' }
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return refreshDrawer();
    })
    .then(function () {
      openDrawer();
    })
    .catch(function (err) {
      console.error('Cart add error:', err);
      form.submit();
    })
    .finally(function () {
      if (submitBtn) submitBtn.disabled = false;
    });
  });

  /* ── Qty changes + remove ─────────────────────────────── */

  drawer.addEventListener('click', function (e) {
    var dec    = e.target.closest(SELECTORS.qtyDec);
    var inc    = e.target.closest(SELECTORS.qtyInc);
    var remove = e.target.closest(SELECTORS.lineRemove);

    if (dec || inc) {
      var line  = (dec || inc).closest(SELECTORS.line);
      var input = line.querySelector(SELECTORS.qtyInput);
      var current = parseInt(input.value, 10) || 0;
      var next = dec ? Math.max(0, current - 1) : current + 1;
      input.value = next;
      updateLineQty(line, next);
    } else if (remove) {
      var removeLine = remove.closest(SELECTORS.line);
      updateLineQty(removeLine, 0);
    }
  });

  var inputTimer = null;
  drawer.addEventListener('input', function (e) {
    if (!e.target.matches(SELECTORS.qtyInput)) return;
    var line = e.target.closest(SELECTORS.line);
    var qty  = Math.max(0, parseInt(e.target.value, 10) || 0);
    clearTimeout(inputTimer);
    inputTimer = setTimeout(function () { updateLineQty(line, qty); }, 500);
  });

  function updateLineQty(line, qty) {
    if (!line) return;
    line.classList.add('varsy-cart-line--updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: line.dataset.lineKey, quantity: qty })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Update failed');
      return refreshDrawer();
    })
    .catch(function (err) {
      console.error('Quantity update error:', err);
      line.classList.remove('varsy-cart-line--updating');
    });
  }

  /* ── Section Rendering API refresh ───────────────────── */

  function getSectionId() {
    var wrapper = drawer.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : 'varsy-cart-drawer';
  }

  function refreshDrawer() {
    var sectionId = getSectionId();
    return fetch('/?sections=' + sectionId)
      .then(function (res) {
        if (!res.ok) throw new Error('Refresh failed');
        return res.json();
      })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) throw new Error('No section data');

        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector(SELECTORS.drawer);
        if (!newDrawer) throw new Error('No drawer in response');

        var newBody  = newDrawer.querySelector(SELECTORS.body);
        var newFoot  = newDrawer.querySelector(SELECTORS.foot);
        var newCount = newDrawer.querySelector(SELECTORS.count);

        var curBody  = drawer.querySelector(SELECTORS.body);
        var curFoot  = drawer.querySelector(SELECTORS.foot);
        var curCount = drawer.querySelector(SELECTORS.count);

        if (newBody  && curBody)  curBody.innerHTML  = newBody.innerHTML;
        if (newCount && curCount) curCount.textContent = newCount.textContent;

        if (newFoot && curFoot) {
          curFoot.outerHTML = newFoot.outerHTML;
        } else if (newFoot && !curFoot) {
          drawer.querySelector('.varsy-cart-drawer__panel').appendChild(newFoot);
        } else if (!newFoot && curFoot) {
          curFoot.remove();
        }

        /* Update header bag count badge if present */
        if (newCount) {
          var countNum = (newCount.textContent.match(/\d+/) || ['0'])[0];
          document.querySelectorAll('[data-cart-count], [data-header-cart-count]').forEach(function (el) {
            el.textContent = countNum;
          });
        }
      })
      .catch(function (err) {
        console.error('Drawer refresh error:', err);
        window.location.reload();
      });
  }

  /* Expose for external use */
  window.VarsyCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
})();
